import React, { createContext, useContext } from "react";
import { useSubscription } from "@/hooks/useSubscription";

type Plan = "free" | "premium" | "pro" | "ultra";

interface PremiumContextType {
  isPremium: boolean;
  isPro: boolean;
  isUltra: boolean;
  isActive: boolean;
  isLoading: boolean;
  plan: Plan;
}

const PremiumContext = createContext<PremiumContextType>({
  isPremium: false,
  isPro: false,
  isUltra: false,
  isActive: false,
  isLoading: true,
  plan: "free",
});

export const PremiumProvider = ({ children }: { children: React.ReactNode }) => {
  const { plan, isPremium, isPro, isUltra, isActive, isLoading } = useSubscription();

  return (
    <PremiumContext.Provider value={{ isPremium, isPro, isUltra, isActive, isLoading, plan }}>
      {children}
    </PremiumContext.Provider>
  );
};

export const usePremium = () => useContext(PremiumContext);
